import React, { useCallback } from 'react';

import ModalCDS from '@sharedCR/coreDesignSystem/Modals/ModalCDS';
import { ModalSize } from '@sharedCR/coreDesignSystem/Modals/ModalCDS/ModalCDS.constants';
import PropTypes from 'prop-types';

import { FILE_MODAL_ID } from '../../FormChangeHistory.constants';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import { getFileModalTitle } from '../../FormChangeHistory.utils';
import TemplateHtmlView from '../TemplateHtmlView';
import TemplatePdfView from '../TemplatePdfView';

/** The file on one side of a change. `side` stays set while the modal closes. */
const TemplateFileModal = ({
  auditId,
  isOpen,
  side = null,
  facts = null,
  isPdf = false,
  onClose,
}) => {
  const renderBody = useCallback(
    () =>
      isPdf ? (
        <TemplatePdfView auditId={auditId} side={side} />
      ) : (
        <TemplateHtmlView auditId={auditId} side={side} />
      ),
    [auditId, side, isPdf],
  );

  return (
    <ModalCDS
      isRestyled
      afterCloseCallback={onClose}
      body={renderBody}
      dataTestId={FormChangeHistoryTestIds.FILE_MODAL}
      header={getFileModalTitle(side, facts)}
      id={FILE_MODAL_ID}
      keepMounted={false}
      open={isOpen && !!side}
      size={ModalSize.FULL}
    />
  );
};

TemplateFileModal.propTypes = {
  auditId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  side: PropTypes.string,
  facts: PropTypes.shape({ savedAt: PropTypes.string }),
  isPdf: PropTypes.bool,
};

export default TemplateFileModal;
